<template>
  <div>
    <PCNavbar selectIndex="1"/>
    <MobileNavBar :currentActive="0"/>
    <CarouselHome />
    <TodoShow/>
    <!-- 注释掉医疗器械供应链的数字化及价值模块
    <div class="bottom_circle">
      <h1>医疗器械供应链的数字化及价值</h1>
      <div class="circle_img">
        <img src="@/assets\d2a10d650c597ed9e4bea0619a18d6ed(1).png" alt="" class="hidden-xs-only"/>
        <img src="@/assets\d2a10d650c597ed9e4bea0619a18d6ed(1).png" alt="" class="hidden-sm-and-up"/>
      </div>
    </div>
    -->
    <CoreCompetence/>
    <CooperationCustomer/>
    <!-- <NewsInfomation/> -->
    <CallMe/>
    <MobileCallme/>
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import CarouselHome from '@/components/carousel_home/index'
import TodoShow from '@/components/todo_show/index'
import CoreCompetence from '@/components/core_competence/index'
import CooperationCustomer from '@/components/cooperation_customer/index'
// import NewsInfomation from '@/components/news_infomation/index'
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    CarouselHome,
    TodoShow,
    CoreCompetence,
    CooperationCustomer,
    // NewsInfomation,
    CallMe,
    MobileCallme
  },
  metaInfo: {
    title: '首页',
    meta: [
      { 
        vmid: 'description', 
        name: 'description', 
        content: '柳叶云提供专业的医疗器械供应链管理软件解决方案，包括智能仓储管理、高值耗材管理、UDI追溯系统、GSP规范管理等，助力医疗器械企业数字化转型。' 
      },
      { 
        vmid: 'keywords', 
        name: 'keywords', 
        content: '医疗器械供应链,医疗器械仓库管理软件,高值耗材,智能仓,UDI追溯,GSP规范' 
      }
    ]
  }
}
</script>

<style lang="scss" scoped>
.bottom_circle {
  width: 100%;
  text-align: center;
  padding-top: 100px;
  background-image: url(../assets/img/smalldot.png),url(../assets/img/smalldot1.png);
  background-position: 0 0,110% 150%;
  background-repeat: no-repeat;
  background-size: 400px;
  h1 {
    font-size: 40px;
    padding-bottom: 20px;
    @media screen and (max-width: 768px) {
      font-size: 1.15rem;
      width: 60%;
      margin: 0 auto;
    }
  }
  .circle_img {
    width: 100%;
    padding: 20px 0;
    img {
      width: 70%;
      max-width: 1200px;
      @media screen and (max-width: 768px) {
        width: 100%;
        margin: 20PX 0;
      }
    }
  }
}
</style>